import { Action, Dispatch } from 'redux'
import { initStocksAction } from 'reducks/stock/actions'

const initStocks = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(initStocksAction())
  }
}

export default initStocks
